<template>
  <div :class="{ 'w-full': open, 'w-18': !open }" class="shadow-navigation flex-grow rounded-10 flex flex-col items-start relative bg-[rgb(var(--color-menu-background))]">
    <div class="w-full overflow-hidden flex items-center">
      <div class="w-18 h-18 flex justify-center items-center flex-shrink-0" @click="$emit('update:open', !open)">
        <img class="w-8" :src="logo" :alt="companyName" />
      </div>
      <span class="font-700 text-20 capitalize flex-shrink-0 text-[rgb(var(--color-menu-text))]">{{ companyName }}</span>
    </div>

    <div class="w-full">
      <NavigationItem
        v-for="(item, index) in navigationItems"
        :key="index"
        class="my-2"
        :text="$t(item.label)"
        :icon="item.icon"
        :iconClass="item.icon === 'logout' ? '!w-7 !h-7' : ''"
        :selected="isNavItemSelected(item)"
        @click="selectNavItem(item)"
        :open="open"
      />
    </div>
    <div class="w-full mt-auto relative">
      <NavigationItem v-tooltip.right="{ content: 'Expand', disabled: open }" :iconClass="open ? 'rotate-180 transform' : ''" icon="slide_panel_open" @click="onToggle" />
      <span v-if="open" class="absolute right-4 top-7 text-[rgb(var(--color-menu-text))]">v{{ version }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NavigationItem from './NavigationItem';
import DeleteModal from '../components/modals/DeleteModal';

export default {
  name: 'Navigation',
  components: { NavigationItem },
  props: {
    open: Boolean,
    navItems: {
      type: Array,
      default: () => [],
    },
    logo: String,
  },
  emits: ['update:open'],
  computed: {
    ...mapState(['user', 'features', 'config']),
    version() {
      return process.env.VUE_APP_VERSION;
    },
    navigationItems() {
      return this.navItems.filter((item) => {
        if (item.restrictTo) {
          return this.features.includes(item.restrictTo);
        }
        return true;
      });
    },
    companyName() {
      return this.config?.brand_name || this.config?.name || 'Fidsy';
    },
  },
  methods: {
    ...mapActions(['logout', 'changeTheme']),
    selectNavItem(item) {
      if (item.to === '/logout') {
        this.$showModal(DeleteModal, {
          title: this.$t('logout'),
          subtitle: this.$t('confirm_logout_message'),
          confirm: this.$t('logout'),
          onConfirm: () => {
            this.logout({ clearIdb: true });
          },
        });
      } else {
        this.changeTheme('default');
        this.$router.push(item.to);
      }
    },
    isNavItemSelected(item) {
      if (item.to.startsWith('/admin')) {
        return this.$route.path.startsWith('/admin') || this.$route.path.startsWith('/iam') || this.$route.path.startsWith('/conversation/');
      }
      if (item.to.startsWith('/user')) {
        return this.$route.path.startsWith('/user');
      }
      if (item.to.startsWith('/project')) {
        return this.$route.path.startsWith('/project');
      }
      if (item.to.startsWith('/collection')) {
        return this.$route.path.startsWith('/collection');
      }
      return this.$route.path === item.to;
    },
    onToggle() {
      this.$emit('update:open', !this.open);
    },
  },
};
</script>
